<!-- todo fix this anchor-start and anchor-end conditional, set this in the component itself! -->
<div class="outer"
  [ngClass]="{
    'disabled': disabled,
    'anchor-start': isAnchorStart,
    'anchor-end': isAnchorEnd,
    'edge': edge,
    'focus': focus === i,
    'cap-end': capEnd,
    'cap-start': capStart,
    'cap-top-left-corner': topLeftCorner,
    'cap-bottom-left-corner': bottomLeftCorner,
    'cap-top-right-corner': topRightCorner,
    'cap-bottom-right-corner': bottomRightCorner,
  }">
  <div class="date"
    [ngClass]="{
      'anchor': anchor,
      'anchor-start': isAnchorStart,
      'anchor-end': isAnchorEnd,
      'edge': edge,
      'focus': focus === i,
      'cap-end': capEnd,
      'cap-start': capStart,
    }">
    <ng-content></ng-content>
  </div>
</div>
